import { Component, Input } from '@angular/core';
import { IDynamicallyCreatedComponent } from '../../core-data-model/DynamicallyCreated.component';
import { DateFormatUtility } from '../../core-utilities/DateFormat.utility';
import { TranslationService } from '../../translations';

class DateConfig {
    date: Date | string;
    tooltip?: string;
}

@Component({
    selector: 'pi-date',
    template: `
        <span
            tooltip
            [tooltipContent]="properties.tooltip"
            [tooltipDisabled]="!properties.tooltip"
            [tooltipAnimation]="true"
            [tooltipDelay]="500"
            tooltipPlacement="top"
        >
            {{ dateUtil.transformDate(properties.date) }}
        </span>
    `,
    standalone: false
})
export class DateComponent implements IDynamicallyCreatedComponent {
    @Input()
    properties: DateConfig;

    constructor(
        public TR: TranslationService,
        public dateUtil: DateFormatUtility
    ) {}
}
